import { useEffect, useRef } from 'react';
import { animate } from 'animejs';
import './SplashScreen.css';

export default function SplashScreen({ onComplete }) {
  const overlayRef = useRef(null);
  const logoRef = useRef(null);

  useEffect(() => {
    const overlay = overlayRef.current;
    const logo = logoRef.current;
    if (!overlay || !logo) return;

    let shakeAnim = null;
    let wobbleAnim = null;
    let shakeTimer = null;

    // Phase 1: Bounce in from top with rotation (1200ms)
    // Mirrors the Flutter elastic bounce: slide from -300, rotate -720deg → 0, scale up
    animate(logo, {
      translateY: ['-300px', '0px'],
      rotate: ['-720deg', '0deg'],
      scale: [0, 1],
      duration: 1200,
      ease: 'outElastic(1, 0.5)',
      onComplete: () => {
        // Phase 2: Continuous shake loop (mirrors Flutter's sine-wave shake)
        shakeAnim = animate(logo, {
          rotate: ['-3.5deg', '3.5deg'],
          duration: 400,
          ease: 'inOutSine',
          loop: true,
          alternate: true,
        });

        wobbleAnim = animate(logo, {
          scale: [1.0, 1.015, 1.0],
          duration: 800,
          ease: 'inOutSine',
          loop: true,
        });

        // Phase 3: After ~1800ms of shaking, stop and fade out overlay
        shakeTimer = setTimeout(() => {
          if (shakeAnim) shakeAnim.pause();
          if (wobbleAnim) wobbleAnim.pause();

          // Snap logo to neutral before fading
          animate(logo, { rotate: '0deg', scale: 1, duration: 80 });

          animate(overlay, {
            opacity: [1, 0],
            duration: 600,
            ease: 'outQuad',
            onComplete: () => onComplete(),
          });
        }, 1800);
      },
    });

    return () => {
      if (shakeTimer) clearTimeout(shakeTimer);
      if (shakeAnim) shakeAnim.pause();
      if (wobbleAnim) wobbleAnim.pause();
    };
  }, [onComplete]);

  return (
    <div ref={overlayRef} className="splash-overlay">
      <img ref={logoRef} src="/logo.png" alt="TasteCircle" className="splash-logo" />
    </div>
  );
}
